import React from "react";

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  function handleLogin(e) {
    e.preventDefault();

    // 🔒 Hardcoded credentials
    if (username === "admin" && password === "Samis.com#312") {
      onLogin(); // success
    } else {
      setError("Invalid username or password");
    }
  }
  const inputStyle = {
    width: "100%",
    padding: "0.6rem",
    marginBottom: "1rem",
    borderRadius: "0.4rem",
    border: "1px solid #cbd5e1",
  };

  const buttonStyle = {
    width: "100%",
    padding: "0.6rem",
    background: " var(--brand-blue)",
    color: "#fff",
    border: "none",
    borderRadius: "0.4rem",
    cursor: "pointer",
  };
  return (
    <div className="page-root">
      <header className="hero">
        <div className="hero-content">
          <h1>Admin Login</h1>
        </div>
      </header>

      <main>
        <section style={{ padding: "4rem 1rem" }}>
          <div
            style={{
              maxWidth: "400px",
              margin: "0 auto",
              background: "#fff",
              padding: "2rem",
              borderRadius: "0.75rem",
              border: "1px solid #e5e7eb",
            }}
          >
            <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
              Login to Dashboard
            </h2>

            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={inputStyle}
              />

              {/* <input
                type="password"
                placeholder="Password"
                value={password}
                disable autocomplete
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
              /> */}
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  autoComplete="off"
                  onChange={(e) => setPassword(e.target.value)}
                  style={inputStyle}
                />

                <label style={{ fontSize: "0.85rem", color: "#475569" }}>
                  <input
                    type="checkbox"
                    checked={showPassword}
                    onChange={() => setShowPassword(!showPassword)}
                    style={{ marginRight: "0.4rem" }}
                  />
                  Show Password
                </label>
              </div>
              {error && (
                <p style={{ color: "red", marginBottom: "1rem" }}>{error}</p>
              )}

              <button
                type="submit"
                style={buttonStyle}
                className="btn-secondary"
              >
                Login
              </button>
            </form>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LoginPage;
